import type { components } from 'admination-react/api-schema'
import { apiListAll, apiPatch, apiPost, type MassnahmeCreate } from '@/core/api/resources'

export type MassnahmeKopf = components['schemas']['MassnahmeKopf']

const MASSNAHME_DEFAULTS = {
  ansprechpartner: '',
  bezeichnung: '',
  durchf_form: '',
  durchf_ort: '',
  inhalt: '',
  nummer: '',
} satisfies Omit<components['schemas']['MassnahmeVergabeWrite'], 'organisation_id'>

function toRow(m: components['schemas']['MassnahmeVergabeRead']) {
  return {
    anwesenheit_stichtag: m.anwesenheit_stichtag,
    aktivierung_zustaendig: m.aktivierung_zustaendig,
    id: m.id,
    nummer: m.nummer,
    bezeichnung: m.bezeichnung,
    durchf_form: m.durchf_form,
    inhalt: m.inhalt,
    durchf_ort: m.durchf_ort,
    ansprechpartner: m.ansprechpartner,
    ue_anzahl: null,
    kosten: null,
    zeitl_umfang_woche: null,
    start_zulassung: null,
    ende_zulassung: null,
    abschluss: null,
    ziele_und_inhalt: null,
  }
}

export async function listMassnahmenFull(organisationId: string) {
  const rows = await apiListAll('/vergabe/massnahme', { organisation_id: organisationId, order: 'nummer' })
  return rows.map(toRow)
}

export async function createMassnahme(organisationId: string, patch: MassnahmeCreate) {
  const created = await apiPost('/vergabe/massnahme', {
    ...MASSNAHME_DEFAULTS,
    ...patch,
    organisation_id: organisationId,
  })
  return toRow(created)
}

export async function updateMassnahme(id: string, patch: components['schemas']['MassnahmeVergabePatch']): Promise<void> {
  await apiPatch('/vergabe/massnahme/{id}', { id }, patch)
}
